export default __webpack_public_path__ + "static/media/60.59d73852.png";